// @ts-nocheck

import { observer, inject } from 'mobx-react';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import { Pharmacy } from '../../store/models/Pharmacy';
import { Instance } from 'mobx-state-tree';
import { PharmacyDetails, PharmacyDetails as PharmacyDetailsEx } from '../../store/models/PharmacyDetails';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { SystemStatus } from '../../store/models/SystemStatus';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import PharmagardeMap from '../common/map/PharmagardeMap';
import { Circle, Polygon, Marker, Polyline, InfoWindow } from '@react-google-maps/api';
import { getUserLocation } from '../../store/utils';

import {
  AuthenticationStore,
  PharmacyStore,
  PharmacyDetailedStore,
  UiStore,
  MunicipalityStore,
  TransferRequestStore,
} from '../../store';
import { Form } from 'react-final-form';
import { PharmacySelectionDetailsTransfer } from './PharmacySelectionDetailsTransfer';
import { NewAddressForm } from './NewAddressForm';
import { TransferCalculationResult } from '../../store/models/TransferCalculationResult';
import { TranslatedMessage } from '../common/translation';
import { TextInput } from '../common/input/basicInputs';
import { Button, Checkbox, Intent, NumericInput, Tooltip, Position as TTPosition, Classes } from '@blueprintjs/core';
import PharmacyMarker from '../common/PharmacyMarker';
import { generateCustomIcon } from '../../common/icons';
import * as geolib from 'geolib';
import * as turf from '@turf/turf';
import { Municipality } from '../../store/models/Municipality';
import proj4 from 'proj4';
import { getHERECoordinatesFromAddress, getHEREAddressFromCoordinates } from '../../api/HEREApi';
import { IconNames } from '@blueprintjs/icons';
import { css } from 'glamor';
import { getCoordinatesFromAddress } from '../../api/OpenStreetMapApi';
import { MunicipalitySelectionDialog } from './Municipalities/MunicipalitySelectionDialog';
import { PharmacyNeighbor } from '../../store/models';
import { AddUserDefinedCircleDialog } from './AddUserDefinedCircleDialog';

const protectionColor = '#fc0d05'; //red

interface SimpleTransferTabProps extends WithTranslateProps {
  duties?: Array<Instance<typeof DutyAssignment>>;
  neighborDuties?: Array<Instance<typeof DutyAssignment>>;
  onExchangeRequesterSelected: (value) => void;
  onExchangeNeighborSelected: (value) => void;
  onSave: () => void;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  municipalityList: Array<Instance<typeof Municipality>>;
  pharmacyNeighboringList: Array<Instance<typeof PharmacyDetailsEx>>;
  onRequesterDutiesSelected: (value) => void;
  onNeighborDutiesSelected: (value) => void;
  getPharmacyById: (id) => any;
  pharmacyUser: boolean;
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  requesterDutiesSelected: number[];
  neighborDutiesSelected: number[];
  withAgreement?: boolean;
  withoutSubstitution?: boolean;
  comment?: string;
  onWithoutSubstitutionChange: () => void;
  onWithAgreementChange: () => void;
  onCommentChange: (value) => void;
  requestorDutiesIsLoading?: boolean;
  neighborDutiesIsLoading?: boolean;
  exchangeIsSaving?: boolean;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  UiStore?: Instance<typeof UiStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  MunicipalityStore?: Instance<typeof MunicipalityStore>;
  TransferRequestStore?: Instance<typeof TransferRequestStore>;
}

interface SimpleTransferTabState {
  notification: string;
  showWithoutSubstitution: boolean;
  //@ts-ignore
  userLocation?: Position;
  initialZoomCalculated: boolean;
  isInsidePolygon: boolean;
  isInsideCircle: boolean;
  isOutsideProtectedCircles: boolean;
  pharmacyToTransferSelected?: Instance<typeof PharmacyDetails>;
  transferCalculationResult?: Instance<typeof TransferCalculationResult>;
  nbrOfNeighbors: number;
  estimatedNbrOfNeighbors?: number;
  maxNbrOfNeighbors: number;
  lengthOfPerpendiculars: number;
  showRadius: boolean;
  showPerpendiculars: boolean;
  showPolygons: boolean;
  showIntersection: boolean;
  show100mCircle: boolean;
  showProtectionCircles: boolean;
  showExclusionCircles: boolean;
  isVerified: boolean;
  newLat: number | undefined;
  newLong: number | undefined;
  mapCenterLat: number | undefined;
  mapCenterLong: number | undefined;
  zoom: number | undefined;
  openMunicipalityDialog: boolean;
  selectedMunicipality: Instance<typeof Municipality>;
  map: google.maps.Map | undefined;
  newPositionMarkerInfoVisible: boolean;
  userAddedCircles: any[] | undefined;
  openAddCircleDialog: boolean;
  userAddedCircleLat: number | undefined;
  userAddedCircleLng: number | undefined;
  searchedAddress: string | undefined;
}

@inject(
  'AuthenticationStore',
  'UiStore',
  'MunicipalityStore',
  'PharmacyStore',
  'PharmacyDetailedStore',
  'TransferRequestStore',
)
@observer
class SimpleTransferTab extends React.Component<SimpleTransferTabProps, SimpleTransferTabState> {
  state = {
    notification: '',
    showWithoutSubstitution: true,
    nbrOfNeighbors: 10,
    maxNbrOfNeighbors: 50,
    lengthOfPerpendiculars: 350000,
    isInsidePolygon: true,
    isInsideCircle: true,
    isOutsideProtectedCircles: true,
    showPerpendiculars: false,
    showPolygons: false,
    showIntersection: true,
    show100mCircle: true,
    showRadius: false,
    showProtectionCircles: false,
    showExclusionCircles: true,
    isVerified: false,
    newLat: undefined,
    newLong: undefined,
    mapCenterLat: 50.58603,
    mapCenterLong: 3.806026,
    zoom: undefined,
    openMunicipalityDialog: false,
    map: undefined,
    newPositionMarkerInfoVisible: false,
    userAddedCircles: undefined,
    openAddCircleDialog: false,
    userAddedCircleLat: undefined,
    userAddedCircleLng: undefined,
    searchedAddress: undefined,
  } as SimpleTransferTabState;

  _isMounted = false;

  H1 = { lat: 49.477868, lng: 2.574613, x: 520000, y: 520000 };
  H2 = { lat: 49.472876, lng: 6.438202, x: 800000, y: 520000 };
  H3 = { lat: 51.988793, lng: 6.55228, x: 800000, y: 800000 };
  H4 = { lat: 51.994055, lng: 2.476674, x: 520000, y: 800000 };

  bbVertices = [this.H1, this.H2, this.H3, this.H4];

  wgs84 = 'EPSG:4326';
  lambert2008 = 'EPSG:3812';

  neighborColor = 'e9ff00'; //yellow

  yellowBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: '#' + this.neighborColor,
    },
    '.bp3-button:hover': {
      backgroundColor: '#' + this.neighborColor,
    },
  });

  blueBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: 'blue',
    },
    '.bp3-button:hover': {
      backgroundColor: 'blue',
    },
  });

  polygonBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: 'purple',
    },
    '.bp3-button:hover': {
      backgroundColor: 'purple',
    },
  });

  greenBackgroundColor = css({
    '.bp3-button': {
      backgroundColor: 'green',
    },
    '.bp3-button:hover': {
      backgroundColor: 'green',
    },
  });

  async componentDidMount() {
    this._isMounted = true;
    const { MunicipalityStore } = this.props;

    try {
      const location = await getUserLocation();
      //ts-ignore
      this._isMounted && this.setState({ userLocation: location });
    } catch (err) {
      //ts-ignore
      //console.error(`Error while getting user location: ${err.message}`);
    }
    MunicipalityStore!.checkListLoaded(); // loadList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getIsDirty = () => {
    return false;
  };

  somethingToSave = () => {
    return true;
  };

  onPharmacyToTransferSelected = async (pharmacyToTransfer: Instance<typeof Pharmacy>) => {
    if (pharmacyToTransfer.pharmacyId !== undefined)
      await this.props.PharmacyDetailedStore!.loadElement(pharmacyToTransfer.pharmacyId)!;
    const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToTransfer.pharmacyId);
    this._isMounted &&
      this.setState({
        pharmacyToTransferSelected: pharmacyDetails,

        // initialZoomCalculated: false,
      });

    await this.props.PharmacyDetailedStore!.loadNeighboringPharmacies(pharmacyToTransfer.pharmacyId);
    const neighbors = pharmacyDetails.pharmacyNeighbors
      .slice()
      .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

    //Load neighbors to display
    await neighbors.slice(0, this.state.nbrOfNeighbors).forEach((item) => {
      if (item.neighborId !== undefined) this.props.PharmacyDetailedStore!.loadElement(item.neighborId);
    });

    //@ts-ignore
    this.props.UiStore!.setCenterCoordinates({ lat: pharmacyToTransfer.latitude, lng: pharmacyToTransfer.longitude });

    if (this.state.transferCalculationResult) {
      this.validateTransfer(pharmacyToTransfer, neighbors.slice(0, this.state.nbrOfNeighbors));
    }

    this.centerAndZoom(pharmacyToTransfer.latitude!, pharmacyToTransfer.longitude!, true);
  };

  buildPolygon = (
    pharmacyToTransferSelected: Instance<typeof PharmacyDetails>,
    neighbors: Array<Instance<typeof PharmacyNeighbor>>,
    markers: any[],
    neighborCount: number,
  ) => {
    let newLocation: any = null;
    // Îcone de destination
    if (this.state.transferCalculationResult) newLocation = this.createNewLocationMarker(newLocation, markers);

    // boundingbox du pays
    this.drawBoundingBox(markers);

    let polygonList: any = [];

    var lat = pharmacyToTransferSelected.latitude;
    var long = pharmacyToTransferSelected.longitude;
    //@ts-ignore
    var pharmacyToTransferLatLong = new google.maps.LatLng(lat, long); //pharmacie à transférer

    let neighborList = neighbors.slice(0, neighborCount);

    // effectuer les calculs pour toutes les pharmacies voisines considérées
    neighborList.forEach((item) => {
      var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
      if (neighbor) {
        this.addNeighborPharmacyMarker(neighbor, markers);

        // calcul en WGS84 et tracé de la perpendicualire en vert flash, segment [F,T]

        this.addLineBetweenNeighborAndPharmacyToTransferToMarkers(neighbor, pharmacyToTransferLatLong, markers);

        let intersections = [];
        const segmentCoordinatesL2008 = this.calculatePerpendicularLambert2008(
          pharmacyToTransferSelected,
          neighbor,
          markers,
          intersections,
          polygonList,
        );
        //WGS84
        proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs');
        const wgs84 = 'EPSG:4326';

        //lambert2008
        proj4.defs(
          'EPSG:3812',
          '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
        );
        const lambert2008 = 'EPSG:3812';

        let pos = proj4(lambert2008, wgs84, [segmentCoordinatesL2008[0].x, segmentCoordinatesL2008[0].y]);
        let CL = { lng: 0, lat: 0 };
        CL.lng = pos[0];
        CL.lat = pos[1];
        pos = proj4(lambert2008, wgs84, [segmentCoordinatesL2008[1].x, segmentCoordinatesL2008[1].y]);
        let DL = { lng: 0, lat: 0 };
        DL.lng = pos[0];
        DL.lat = pos[1];

        const perpendicularDCL2008 = (
          <>
            {this.state.showPerpendiculars && (
              <Polyline
                key={'perpendicular-' + item.neighborId}
                path={[CL, DL]}
                options={{
                  geodesic: true,
                  strokeColor: 'red',
                  strokeOpacity: 1.0,
                  strokeWeight: 1,
                }}
              />
            )}
          </>
        );
        markers.push(perpendicularDCL2008); // tracé de la perpendiculaire au 1/4 de la distance entre pharmacie à transférer A et une voisine C

        this.drawProtectionCircles(neighbor, markers);
      }
    });

    const isInsideCircle = this.isInsideCircle(pharmacyToTransferLatLong, newLocation, 100);
    if (this.state.isInsideCircle !== isInsideCircle) {
      this.setState({
        isInsideCircle: isInsideCircle,
      });
    }
    //const allPharmaciesForProtection = [...neighborList, pharmacyToTransferSelected];

    //this.determineStateOutsideProtectedCircle(newLocation, allPharmaciesForProtection);

    const finalPolygon = this.intersectPolygonsL2008(polygonList); // calcul du polygone qui est l'interection des différents polygones

    let isInsidePolygon = true;
    neighborList.forEach((item) => {
      var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
      if (neighbor !== undefined) {
        const flag = this.isInsidePolygon(pharmacyToTransferLatLong, neighbor, newLocation);
        if (!flag) {
          isInsidePolygon = false;
          return;
        }
      }
    });
    if (this.state.isInsidePolygon !== isInsidePolygon) {
      this.setState({ isInsidePolygon: isInsidePolygon });
    }

    const finalPolygonArray = [finalPolygon]; // [] requis dessin de polygone

    const polygon = (
      <>
        {this.state.showIntersection && (
          <Polygon
            key={'insiderPolygon'}
            paths={finalPolygonArray}
            options={{
              geodesic: true,
              fillOpacity: 0.5,
              fillColor: '#106BA3',
              strokeColor: 'blue',
              strokeOpacity: 0.3,
              strokeWeight: 0.5,
            }}
            onRightClick={(e) => {
              //@ts-ignore
              google.maps.event.trigger(this.state.map, 'rightclick', e);
            }}
          />
        )}
      </>
    );
    markers.push(polygon);

    return finalPolygon;
  };

  calculatePerpendicularLambert2008 = (ph, n, markers, intersections, polygonList) => {
    // formule de Wouter pour comparer
    let yD = (3 * ph.y + n.y) / 4;
    let xD = (3 * ph.x + n.x) / 4;

    let numStabOnX = false;
    // Determine the numerical stability on either X or Y
    if (Math.abs(ph.x - n.x) > Math.abs(ph.y - n.y)) numStabOnX = true; // then, use x = ay + b, otherwise, use y = ax + b
    // xQ, yQ est sur la droite L => x = al*y + bl
    const al = numStabOnX ? (ph.y - n.y) / (n.x - ph.x) : (ph.x - n.x) / (n.y - ph.y);
    // if (n.apbNumber === 853101 || n.apbNumber === 851901) {
    //   console.log('al ' + al);
    // }
    const bl = numStabOnX
      ? (3 * ph.x + n.x) / 4 + ((n.y - ph.y) * (3 * ph.y + n.y)) / (4 * (n.x - ph.x))
      : (3 * ph.y + n.y) / 4 - ((ph.x - n.x) * (3 * ph.x + n.x)) / (4 * (n.y - ph.y));

    const H1 = this.H1;
    const H2 = this.H2;
    const H3 = this.H3;
    const H4 = this.H4;

    let pos;

    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, H1, 'H1', markers, intersections, numStabOnX);
    const xH2 = numStabOnX ? al * H2.y + bl : (H2.y - bl) / al;
    pos = proj4(this.lambert2008, this.wgs84, [xH2, H2.y]);
    const S3 = { lng: pos[0], lat: pos[1], x: xH2, y: H2.y };
    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, S3, 's3', markers, intersections, numStabOnX);

    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, H2, 'H2', markers, intersections, numStabOnX);
    const yH2 = numStabOnX ? (H2.x - bl) / al : al * H2.x + bl;
    pos = proj4(this.lambert2008, this.wgs84, [H2.x, yH2]);
    const S2 = { lng: pos[0], lat: pos[1], x: H2.x, y: yH2 };
    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, S2, 's2', markers, intersections, numStabOnX);

    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, H3, 'H3', markers, intersections, numStabOnX);
    const xH4 = numStabOnX ? al * H4.y + bl : (H4.y - bl) / al;
    pos = proj4(this.lambert2008, this.wgs84, [xH4, H4.y]);
    const S4 = { lng: pos[0], lat: pos[1], x: xH4, y: H4.y };
    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, S4, 's4', markers, intersections, numStabOnX);

    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, H4, 'H4', markers, intersections, numStabOnX);
    const yH1 = numStabOnX ? (H1.x - bl) / al : H1.x * al + bl;
    pos = proj4(this.lambert2008, this.wgs84, [H1.x, yH1]);
    const S1 = { lng: pos[0], lat: pos[1], x: H1.x, y: yH1 }; //si x = al*y + bl
    this.calculateIntersectionPoint(ph.x, ph.y, al, bl, S1, 's1', markers, intersections, numStabOnX);

    intersections.push(intersections[0]); // pour fermer le polygone sur le point de départ

    const polygon = (
      <>
        {this.state.showPolygons && (
          <Polygon
            paths={intersections}
            options={{
              geodesic: true,
              fillColor: 'red',
              fillOpacity: 0.1,
              strokeColor: 'red',
              strokeOpacity: 0.7,
              strokeWeight: 4,
            }}
            onRightClick={(e) => {
              //@ts-ignore
              google.maps.event.trigger(this.state.map, 'rightclick', e);
            }}
          />
        )}
      </>
    );
    markers.push(polygon);
    polygonList.push(intersections);

    // const y1 = yD - 50000;
    // const x1 = al * y1 + bl;
    // const y = yD;
    // const x = xD; // numStabOnX?al * y + bl:(y-bl)/al;
    // const y2 = yD + 50000;
    // const x2 = al * y2 + bl;

    const y1 = !numStabOnX ? al * (xD - 50000) + bl : yD - 50000;
    const x1 = !numStabOnX ? xD - 50000 : al * (yD - 50000) + bl;
    const y = yD;
    const x = xD;
    const y2 = !numStabOnX ? al * (xD + 50000) + bl : yD + 50000;
    const x2 = !numStabOnX ? xD + 50000 : al * (yD + 50000) + bl;

    // if (n.apbNumber === 853101 || n.apbNumber === 851901) {
    //   console.log('y2 : ' + y2);
    //   console.log('x2 : ' + x2);
    //   console.log('yD : ' + yD);
    //   console.log('bl : ' + bl);
    // }

    pos = proj4(this.lambert2008, this.wgs84, [x, y]);
    let CL = { lng: 0, lat: 0 };
    CL.lng = pos[0];
    CL.lat = pos[1];
    pos = proj4(this.lambert2008, this.wgs84, [x2, y2]);
    let DL = { lng: 0, lat: 0 };
    DL.lng = pos[0];
    DL.lat = pos[1];

    // if (n.apbNumber === 853101 || n.apbNumber === 851901) {
    //   console.log('CL.lng : ' + CL.lng);
    //   console.log('CL.lat : ' + CL.lat);
    //   console.log('DL.lng : ' + DL.lng);
    //   console.log('DL.lat : ' + DL.lat);
    // }
    // segment 1
    const perpendicularDCL2008_1 = (
      <>
        {this.state.showPerpendiculars && (
          <Polyline
            path={[CL, DL]}
            options={{
              geodesic: true,
              strokeColor: 'red',
              strokeOpacity: 1.0,
              strokeWeight: 1,
            }}
          />
        )}
      </>
    );
    markers.push(perpendicularDCL2008_1);

    pos = proj4(this.lambert2008, this.wgs84, [x1, y1]);
    DL = { lng: 0, lat: 0 };
    DL.lng = pos[0];
    DL.lat = pos[1];

    // segment 2, dir opposée
    const perpendicularDCL2008_2 = (
      <>
        {this.state.showPerpendiculars && (
          <Polyline
            path={[CL, DL]}
            options={{
              geodesic: true,
              strokeColor: 'red',
              strokeOpacity: 1.0,
              strokeWeight: 1,
            }}
          />
        )}
      </>
    );
    markers.push(perpendicularDCL2008_2);

    return [
      {
        x: x,
        y: y,
      },
      {
        x: x2,
        y: y2,
      },
    ];
  };

  // vérifier si "point" est sur la bordure (ou à l'intérieur) de la boundig box H1 - H2 - H3 - H4 avec H1 en bas à gauche et H2 en bas à droite
  isOnBoundingBoxBorder = (point) => {
    return (
      point.x >= Math.min(this.H1.x, this.H4.x) &&
      point.x <= Math.max(this.H2.x, this.H3.x) &&
      point.y >= Math.min(this.H1.y, this.H2.y) &&
      point.y <= Math.max(this.H4.y, this.H3.y)
    );
  };

  calculateIntersectionPoint = (
    pharmacyX,
    pharmacyY,
    ac,
    bc,
    candidateIntersectionPoint,
    label,
    markers,
    intersections,
    numStabOnX,
  ) => {
    if (this.isOnBoundingBoxBorder(candidateIntersectionPoint)) {
      if (this.areOnSameSide(pharmacyX, pharmacyY, candidateIntersectionPoint, ac, bc, numStabOnX)) {
        let targetIcon = generateCustomIcon(20, 20, 'ffff00', 'ffff00', false, '000000', false, '888888', '1', '1');

        const newPosition = (
          <Marker
            position={{
              lat: candidateIntersectionPoint.lat,

              lng: candidateIntersectionPoint.lng,
            }}
            icon={targetIcon}
            label={label}
          />
        );

        markers.push(newPosition);

        intersections.push(candidateIntersectionPoint);
      }
    }
  };

  areOnSameSide = (pharmacyX, pharmacyY, point, ac, bc, numStabOnX) => {
    const test = numStabOnX
      ? (ac * pharmacyY + bc - pharmacyX) * (ac * point.y + bc - point.x)
      : (ac * pharmacyX + bc - pharmacyY) * (ac * point.x + bc - point.y);
    return test >= -5e-3; // PG-1123 JLL changed: remplacé -5e-5 par -5e-3
  };

  plotPoint = (point, icon, label, markers, intersections) => {
    const position = (
      <Marker
        position={{
          lat: point.lat,

          lng: point.lng,
        }}
        icon={icon}
        label={label}
      />
    );

    markers.push(position);

    intersections.push(point);
  };

  // vérifier si "point" est sur la bordure de la boundig box H1 - H2 - H3 - H4 avec H1 en bas à gauche et H2 en bas à droite
  isOnBoundingBoxBorderWGS84 = (point) => {
    const test =
      point.lng >= this.H1.lng && point.lng <= this.H2.lng && point.lat >= this.H1.lat && point.lat <= this.H4.lat;
    return test;
  };

  areOnSameSideWGS84 = (pharmacy, point, ac, bc) => {
    // const test = ((ac*pharmacy.latitude + bc - pharmacy.longitude) * (ac*point.lat + bc - point.lng))
    const test = (ac * pharmacy.latitude + bc - pharmacy.longitude) * (ac * point.lat + bc - point.lng);
    return test >= 0;
  };

  intersectPolygonsWGS84 = (polygonList, markers) => {
    while (polygonList.length > 1) {
      const pol1 = polygonList[0];
      polygonList.shift();
      const pol2 = polygonList[0];
      polygonList.shift();

      let turfPoly1: any = [];
      pol1.forEach((element) => {
        turfPoly1.push([element.lng, element.lat]);
      });
      turfPoly1.push(turfPoly1[0]);
      const turfPoly1B = [turfPoly1];
      const turf1 = turf.polygon(turfPoly1B);

      let turfPoly2: any = [];
      pol2.forEach((element) => {
        turfPoly2.push([element.lng, element.lat]);
      });
      turfPoly2.push(turfPoly2[0]);

      const turfPoly2B = [turfPoly2];
      const turf2 = turf.polygon(turfPoly2B);

      if (turfPoly1B[0].length > 3 && turfPoly2B[0].length > 3) {
        const finalPol1 = turf1; //turf.polygon(turfPoly1);
        const finalPol2 = turf2; // turf.polygon(turfPoly2)
        const intersect = turf.intersect(finalPol1, finalPol2);
        if (intersect && intersect.geometry.type == 'Polygon' && intersect.geometry.coordinates.length == 1) {
          let intersectList: any = [];
          intersect.geometry.coordinates[0].forEach((coordArray) => {
            intersectList.push({ lng: coordArray[0], lat: coordArray[1] });
          });
          polygonList.push(intersectList);
          const polygon = (
            <>
              <Polygon
                paths={intersectList}
                options={{
                  geodesic: true,
                  fillOpacity: 0,
                  strokeColor: 'yellow',
                  strokeOpacity: 0.7,
                  strokeWeight: 4,
                }}
                onRightClick={(e) => {
                  //@ts-ignore
                  google.maps.event.trigger(this.state.map, 'rightclick', e);
                }}
              />
            </>
          );
          markers.push(polygon);
        }
      }
    }

    return polygonList[0];
  };

  getSmallestPolygonIncludingPoint = (lines, intersections, pharmacyToTransferCoordinates) => {
    const point = turf.point([pharmacyToTransferCoordinates.x, pharmacyToTransferCoordinates.y]);
    let closestIntersection: turf.helpers.Feature<turf.helpers.Point, turf.helpers.Properties>;
    let shortestDistance = Number.MAX_VALUE;
    intersections.forEach((intersection) => {
      const intersectionPoint = turf.point(intersection);
      const distanceToIntersection = turf.distance(point, intersectionPoint);
      if (distanceToIntersection < shortestDistance) {
        shortestDistance = distanceToIntersection;
        closestIntersection = intersectionPoint;
      }
    });

    //closestIntersection is now our startingPoint.

    // Take all the lines on which our point is part of. Should be at least 2. And very very unlikely that's more than two.
    const crossedLines = lines.filter((l) => turf.booleanPointOnLine(closestIntersection.geometry.coordinates, l));
  };

  intersectPolygonsL2008 = (polygonList) => {
    while (polygonList.length > 1) {
      const pol1 = polygonList[0];
      polygonList.shift();
      const pol2 = polygonList[0];
      polygonList.shift();

      let turfPoly1: any = [];
      pol1.forEach((element) => {
        turfPoly1.push([element.x, element.y]);
      });
      turfPoly1.push(turfPoly1[0]);
      const turfPoly1B = [turfPoly1];
      const turf1 = turf.polygon(turfPoly1B);

      let turfPoly2: any = [];
      pol2.forEach((element) => {
        turfPoly2.push([element.x, element.y]);
      });
      turfPoly2.push(turfPoly2[0]);
      const turfPoly2B = [turfPoly2];
      const turf2 = turf.polygon(turfPoly2B);

      const result = turf.area(turf2);

      if (turfPoly1B[0].length > 3 && turfPoly2B[0].length > 3) {
        const finalPol1 = turf1; //turf.polygon(turfPoly1);
        const finalPol2 = turf2; // turf.polygon(turfPoly2)
        const intersect = turf.intersect(finalPol1, finalPol2);
        if (intersect && intersect.geometry.type == 'Polygon' && intersect.geometry.coordinates.length == 1) {
          let intersectList: any = [];
          intersect.geometry.coordinates[0].forEach((coordArray) => {
            intersectList.push({ x: coordArray[0], y: coordArray[1] });
          });
          intersectList.forEach((item) => {
            var pos = proj4(this.lambert2008, this.wgs84, [item.x, item.y]);
            item.lat = pos[1];
            item.lng = pos[0];
          });
          polygonList.push(intersectList);
        }
      }
    }

    return polygonList[0];
  };

  intersectPolygons = (polygonList, markers) => {
    while (polygonList.length > 1) {
      const pol1 = polygonList[0];
      polygonList.shift();
      const pol2 = polygonList[0];
      polygonList.shift();

      let turfPoly1: any = [];
      pol1.forEach((element) => {
        turfPoly1.push([element.lng, element.lat]);
      });
      turfPoly1.push(turfPoly1[0]);
      const turfPoly1B = [turfPoly1];
      const turf1 = turf.polygon(turfPoly1B);

      let turfPoly2: any = [];
      pol2.forEach((element) => {
        turfPoly2.push([element.lng, element.lat]);
      });
      turfPoly2.push(turfPoly2[0]);
      const turfPoly2B = [turfPoly2];
      const turf2 = turf.polygon(turfPoly2B);

      if (turfPoly1B[0].length > 3 && turfPoly2B[0].length > 3) {
        const finalPol1 = turf1; //turf.polygon(turfPoly1);
        const finalPol2 = turf2; // turf.polygon(turfPoly2)
        const intersect = turf.intersect(finalPol1, finalPol2);
        if (intersect && intersect.geometry.type == 'Polygon' && intersect.geometry.coordinates.length == 1) {
          let intersectList: any = [];
          intersect.geometry.coordinates[0].forEach((coordArray) => {
            intersectList.push({ lng: coordArray[0], lat: coordArray[1] });
          });
          polygonList.push(intersectList);
        }
      }
    }

    return polygonList[0];
  };

  drawBoundingBox = (markers) => {
    const boundingBox = (
      <Polygon
        paths={this.bbVertices}
        options={{
          geodesic: true,
          // fillColor: 'red',
          fillOpacity: 0,
          strokeColor: 'black',
          strokeOpacity: 0.5,
          strokeWeight: 2,
        }}
        onRightClick={(e) => {
          //@ts-ignore
          google.maps.event.trigger(this.state.map, 'rightclick', e);
        }}
      />
    );
    markers.push(boundingBox);
  };

  isOutsideProtectedCircles = (newLocation, neighbor) => {
    if (newLocation) {
      var outside = true;
      var neighborPh: any = {};
      if (neighbor.hasOwnProperty('apbNumber')) neighborPh = neighbor;
      else neighborPh = this.props.PharmacyStore!.getById(neighbor.neighborId);
      if (!neighborPh) return this.state.isOutsideProtectedCircles;
      const protections = this.props.TransferRequestStore!.dataList.filter(
        (tr) => tr.apbNumber === neighborPh!.apbNumber,
      );
      if (protections) {
        // if (neighbor.protections) {
        // neighbor.protections
        protections
          .filter((p) => p.decision === '+' && new Date(p.protectionEndDate) >= new Date())
          // .filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())
          .map((pr) => {
            var result = geolib.isPointWithinRadius(
              { latitude: newLocation.lat(), longitude: newLocation.lng() },
              { latitude: neighborPh!.latitude!, longitude: neighborPh!.longitude! },
              // { latitude: neighbor.latitude, longitude: neighbor.longitude },
              pr.protectionRange! > 0 ? pr.protectionRange! : 0,
              // pr.range,
            );
            if (result) {
              outside = false;
            }
          });
      }
      return outside;
    } else return this.state.isOutsideProtectedCircles; //true;
  };

  determineStateOutsideProtectedCircle = (newLocation, allPharmaciesForProtection) => {
    if (allPharmaciesForProtection.find((ph) => !this.isOutsideProtectedCircles(newLocation, ph)) !== undefined) {
      if (this.state.isOutsideProtectedCircles !== false) {
        this.setState({ isOutsideProtectedCircles: false });
      }
    } else {
      if (this.state.isOutsideProtectedCircles !== true) {
        this.setState({ isOutsideProtectedCircles: true });
      }
    }
  };

  isInsideCircle = (F, T, diam) => {
    // console.log('isInsideCircle?');
    if (T) {
      var result = geolib.isPointWithinRadius(
        { latitude: T.lat(), longitude: T.lng() },
        { latitude: F.lat(), longitude: F.lng() },
        diam,
      );
      return result;
    } else return false;
  };

  isInsidePolygon = (From, neighbor, To) => {
    if (From && To) {
      //lambert2008
      proj4.defs(
        'EPSG:3812',
        '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      );

      const A = From;
      const FromLamb = proj4(this.wgs84, this.lambert2008, [A.lng(), A.lat()]);
      const Ax = FromLamb[0];
      const Ay = FromLamb[1];

      const C = neighbor;
      const NeighborLamb = proj4(this.wgs84, this.lambert2008, [C.longitude, C.latitude]);
      const Cx = NeighborLamb[0];
      const Cy = NeighborLamb[1];

      const T = To;
      const ToLamb = proj4(this.wgs84, this.lambert2008, [T.lng(), T.lat()]);
      const Tx = ToLamb[0];
      const Ty = ToLamb[1];

      const ac = (Ax - Cx) / (Cy - Ay);
      const bc = (3 * Ay + Cy) / 4 + ((Cx - Ax) * (3 * Ax + Cx)) / (4 * (Cy - Ay));
      const test = (ac * Ax + bc - Ay) * (ac * Tx + bc - Ty);

      return test > 0;
    } else return false;
  };

  onLoadCircle = (circle) => {
    const bounds = circle.getBounds();
  };

  // drawProtectionCircles = (neighbor, markers) => {
  //   if (this.hasProtection(neighbor)) {
  //     neighbor.protections
  //       .filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())
  //       .forEach((element) => {
  //         let protectedCircle = (
  //           <>
  //             {this.state.showProtectionCircles && (
  //               <Circle
  //                 key={'protection-' + neighbor.pharmacyId}
  //                 center={{ lat: neighbor.latitude, lng: neighbor.longitude }}
  //                 radius={element.range}
  //                 options={{
  //                   fillColor: protectionColor, //'red',

  //                   strokeWeight: 0.4,

  //                   strokeOpacity: 0.5,
  //                 }}
  //                 onRightClick={(e) => {
  //                   google.maps.event.trigger(this.state.map, 'rightclick', e);
  //                 }}
  //               ></Circle>
  //             )}
  //           </>
  //         );

  //         markers.push(protectedCircle);
  //       });
  //   }
  // };

  drawProtectionCircles = (neighbor, markers) => {
    if (this.hasProtection(neighbor)) {
      // neighbor.protections
      this.props
        .TransferRequestStore!.dataList.filter((tr) => tr.apbNumber === neighbor.apbNumber)
        .filter((p) => p.decision === '+' && new Date(p.protectionEndDate) >= new Date())
        // .filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())
        .forEach((element) => {
          let protectedCircle = (
            <>
              {this.state.showProtectionCircles && (
                <Circle
                  key={'protection-' + neighbor.pharmacyId}
                  center={{ lat: neighbor.latitude, lng: neighbor.longitude }}
                  radius={element.protectionRange}
                  // radius={element.range}
                  options={{
                    fillColor: protectionColor, //'red',

                    strokeWeight: 0.4,

                    strokeOpacity: 0.5,
                  }}
                  onRightClick={(e) => {
                    //@ts-ignore
                    google.maps.event.trigger(this.state.map, 'rightclick', e);
                  }}
                ></Circle>
              )}
            </>
          );

          markers.push(protectedCircle);
        });
    }
  };

  hasProtection = (pharmacy) => {
    // const res = pharmacy.protections.length > 0;
    const res2 = pharmacy.protections.length > 0;
    const res =
      this.props.TransferRequestStore!.dataList.filter((tr) => tr.apbNumber === pharmacy.apbNumber).length > 0;
    return res;
  };

  isProtected = (pharmacy) => {
    return true;
  };

  orientationX = (p, q, r) => {
    let val = (q.lat() - p.lat()) * (r.lng() - q.lng()) - (q.lng() - p.lng()) * (r.lat() - q.lat());

    if (val == 0) return 0; // collinear
    return val > 0 ? 1 : 2; // clock or counterclock wise
  };

  private openAddCircleToMarkerDialog = (lat: number, lng: number) => {
    this.setState({ openAddCircleDialog: true, userAddedCircleLat: lat, userAddedCircleLng: lng });
  };

  private onCircleAdded = (lat: number, lng: number, radius: number) => {
    const circle = (
      <Circle
        key={'addedCircle-' + lat + lng + radius}
        center={{ lat, lng }}
        radius={radius}
        options={{
          fillColor: '#ADD8E6',
          strokeWeight: 0.5,
        }}
        onRightClick={(e) => {
          //@ts-ignore
          google.maps.event.trigger(this.state.map, 'rightclick', e);
        }}
      />
    );
    if (this.state.userAddedCircles === undefined) this.setState({ userAddedCircles: [circle] });
    else this.setState({ userAddedCircles: [...this.state.userAddedCircles, circle] });
  };

  renderPharmacyMarkers = () => {
    const { pharmacyToTransferSelected, show100mCircle } = this.state;

    const pharmacyList: any = [];
    pharmacyList.push(pharmacyToTransferSelected);
    let selectedColor = '00ff11';
    let icon = generateCustomIcon(20, 20, selectedColor, selectedColor, true, '000000', false, '888888', '1', '1');
    let level0Icon = generateCustomIcon(
      20,
      20,
      selectedColor,
      selectedColor,
      false,
      '000000',
      false,
      '888888',
      '1',
      '1',
    );

    let markers: any = [];

    if (pharmacyToTransferSelected) {
      const pharmacyToTransferMarker = (
        <PharmacyMarker
          key={'transfered-' + pharmacyToTransferSelected.pharmacyId}
          id={pharmacyToTransferSelected.pharmacyId}
          marker={pharmacyToTransferSelected}
          zIndex={100}
          icon={pharmacyToTransferSelected.level === 3 ? icon : level0Icon}
          groupEditMode={false}
          disableRightClick
          onAddCircle={this.openAddCircleToMarkerDialog}
        />
      );

      markers.push(pharmacyToTransferMarker);

      const pharmacyToTransferCircle = (
        <>
          {show100mCircle && (
            <Circle
              key={'circle100m-' + pharmacyToTransferSelected.pharmacyId}
              center={{
                lat: pharmacyToTransferSelected!.latitude as number,
                lng: pharmacyToTransferSelected!.longitude as number,
              }}
              radius={100}
              options={{
                fillColor: '#106BA3',
                fillOpacity: 0.5,
                strokeWeight: 0.5,
              }}
              onRightClick={(e) => {
                //@ts-ignore
                google.maps.event.trigger(this.state.map, 'rightclick', e);
              }}
            />
          )}
        </>
      );
      markers.push(pharmacyToTransferCircle);

      this.drawProtectionCircles(pharmacyToTransferSelected, markers);

      // let backup = new Array(markers);
      const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToTransferSelected.pharmacyId);
      if (pharmacyDetails) {
        const neighbors = pharmacyDetails.pharmacyNeighbors
          .slice()
          .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));
        if (neighbors) {
          const polygon = this.buildPolygon(
            pharmacyToTransferSelected,
            neighbors,
            markers,
            this.state.nbrOfNeighbors, //cptr
          );
        }
      }
    }
    return markers;
  };

  estimateNeighborCount = () => {
    const { pharmacyToTransferSelected } = this.state;

    if (pharmacyToTransferSelected) {
      let markers: any = [];
      let backup = new Array(markers);
      let previousArea;
      let currentArea;
      let count = 0;
      const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToTransferSelected.pharmacyId);
      if (pharmacyDetails) {
        const neighbors = pharmacyDetails.pharmacyNeighbors
          .slice()
          .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));
        // this.props.PharmacyDetailedStore!.loadElement(neighbors[cptr - 1].neighborId);
        if (neighbors) {
          let areas: number[] = [];
          markers = new Array(backup);
          for (let cptr = 5; cptr < this.state.maxNbrOfNeighbors; cptr += 1) {
            if (neighbors[cptr].neighborId !== undefined)
              this.props.PharmacyDetailedStore!.loadElement(neighbors[cptr].neighborId);

            const polygon = this.buildPolygon(pharmacyToTransferSelected, neighbors, markers, cptr);
            if (polygon) {
              console.log(polygon);
              //@ts-ignore
              currentArea = window.google.maps.geometry.spherical.computeArea(polygon);
              console.log('area (m2): ' + previousArea + '  ' + currentArea + '  for ' + cptr);
              areas.push(currentArea);
              if (previousArea != currentArea) {
                count = 0;
                console.log('different => ' + count);
              } else {
                count += 1;
                console.log('equal => ' + count);
                if (count > 10) {
                  console.log('return ' + (cptr - count));
                  this.setState({ estimatedNbrOfNeighbors: cptr - count });
                  console.log(areas);
                  return;
                }
              }
              previousArea = currentArea;
            }
          }
          console.log(areas);
        }
      }
    }
  };

  getPolygonCoordinates = (): Array<google.maps.LatLng> => {
    let polygonCoordinates: Array<google.maps.LatLng> = [];

    const { pharmacyToTransferSelected } = this.state;

    let markers: any = [];

    if (pharmacyToTransferSelected !== undefined) {
      const pharmacyDetails = this.props.PharmacyDetailedStore!.getByIdOrNew(pharmacyToTransferSelected.pharmacyId);
      if (pharmacyDetails) {
        const neighbors = pharmacyDetails.pharmacyNeighbors
          .slice()
          .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));
        if (neighbors) {
          polygonCoordinates = this.buildPolygon(
            pharmacyToTransferSelected,
            neighbors,
            markers,
            this.state.nbrOfNeighbors,
          ) as Array<google.maps.LatLng>;
        }
      }
    }

    return polygonCoordinates;
  };

  calculateVerticesV2 = (lines, center) => {
    let intersections: any = [];

    lines.forEach((line1) => {
      lines.forEach((line2) => {
        if (line1 != line2) {
          //calculate line1 intersect line2
          var intersects = turf.lineIntersect(
            turf.lineString([[line1[0].lng(), line1[0].lat()], [line1[1].lng(), line1[1].lat()]]),
            turf.lineString([[line2[0].lng(), line2[0].lat()], [line2[1].lng(), line2[1].lat()]]),
          );
          //@ts-ignore
          var intersectionWGS84 = new google.maps.LatLng(
            intersects.features[0].geometry.coordinates[0],
            intersects.features[0].geometry.coordinates[1],
          );
          intersections.push(intersectionWGS84);
        }
      });
    });
    return intersections;
  };

  calculateVertices = (lines, center) => {
    let intersections: any = [];

    lines.forEach((line1) => {
      let minDist = 100000;
      lines.forEach((line2) => {
        if (line1 != line2) {
          //calculate line1 intersect line2
          const intersection = this.intersect(line1, line2);
          if (intersection) {
            let dist = geolib.getDistance(
              { latitude: center.lat(), longitude: center.lng() },
              { latitude: intersection.lat(), longitude: intersection.lng() },
              1,
            );
            if (dist < minDist) {
              minDist = dist;
              //push into vertices
              intersections.push(intersection);
            }
          }
        }
      });
    });
    return intersections;
  };

  intersect2 = (line1, line2) => {
    const x1 = line1[0].lat();
    const y1 = line1[0].lng();
    const x2 = line1[1].lat();
    const y2 = line1[1].lng();
    const x3 = line2[0].lat();
    const y3 = line2[0].lng();
    const x4 = line2[1].lat();
    const y4 = line2[1].lng();
    // Check if none of the lines are of length 0
    if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
      return false;
    }

    const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

    // Lines are parallel
    if (denominator === 0) {
      return false;
    }

    let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
    let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

    // is the intersection along the segments
    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
      return false;
    }

    // Return a object with the x and y coordinates of the intersection
    let x = x1 + ua * (x2 - x1);
    let y = y1 + ua * (y2 - y1);

    //@ts-ignore
    const point = new google.maps.LatLng(x, y);
    return point;
  };

  // line intercept math by Paul Bourke http://paulbourke.net/geometry/pointlineplane/
  // Determine the intersection point of two line segments
  // Return FALSE if the lines don't intersect
  intersect = (line1, line2) => {
    const x1 = line1[0].lat();
    const y1 = line1[0].lng();
    const x2 = line1[1].lat();
    const y2 = line1[1].lng();
    const x3 = line2[0].lat();
    const y3 = line2[0].lng();
    const x4 = line2[1].lat();
    const y4 = line2[1].lng();
    // Check if none of the lines are of length 0
    if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
      return false;
    }

    const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

    // Lines are parallel
    if (denominator === 0) {
      return false;
    }

    let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
    let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

    // is the intersection along the segments
    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
      return false;
    }

    // Return a object with the x and y coordinates of the intersection
    let x = x1 + ua * (x2 - x1);
    let y = y1 + ua * (y2 - y1);

    //@ts-ignore
    const point = new google.maps.LatLng(x, y);
    return point;
  };

  handleNbrOfNeighborsChanged = (_valueAsNumber: number, valueAsString: string) => {
    // console.log(_valueAsNumber);
    const neighbors = (this.state.pharmacyToTransferSelected as any).pharmacyNeighbors
      .slice()
      .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));

    if (neighbors[_valueAsNumber - 1].neighborId !== undefined)
      this.props.PharmacyDetailedStore!.loadElement(neighbors[_valueAsNumber - 1].neighborId);

    if (this.state.nbrOfNeighbors !== _valueAsNumber) this.setState({ nbrOfNeighbors: _valueAsNumber });

    if (this.state.transferCalculationResult) {
      this.validateTransfer(this.state.pharmacyToTransferSelected, neighbors.slice(0, this.state.nbrOfNeighbors));
    }
  };

  lengthOfPerpendicularsChanged = (obj) => {
    // console.log(obj.target.value);
    this.setState({ lengthOfPerpendiculars: obj.target.value });
    // this.setState({ initialZoomCalculated: false });
  };

  verifyCoordinates = () => {
    //TODO
    if (!this.state.isVerified) this.setState({ isVerified: true });
  };

  centerAndZoom = (
    centerLat: number,
    centerLong: number,
    includeNeighbors: boolean = false,
    includePolygon = false,
  ) => {
    this.calculateZoom(centerLat, centerLong, includeNeighbors, includePolygon);
  };

  calculateZoom = (
    centerLat: number,
    centerLong: number,
    includeNeighbors: boolean = false,
    includePolygon = false,
  ) => {
    if (this.state.map !== undefined) {
      let currentMarkerPositions: google.maps.LatLng[] = [];
      var bounds = new google.maps.LatLngBounds();
      var hasBoundExtended = false;

      const pharmacyDetails = this.state.pharmacyToTransferSelected;

      if (pharmacyDetails !== undefined) {
        // Add selected pharmacy position
        currentMarkerPositions.push(
          new google.maps.LatLng(pharmacyDetails.latitude as number, pharmacyDetails.longitude as number),
        );

        if (includeNeighbors)
          //add neighbors position
          pharmacyDetails.pharmacyNeighbors
            .slice()
            .sort((a, b) =>
              (a.distance as number) > (b.distance as number)
                ? 1
                : (b.distance as number) > (a.distance as number)
                ? -1
                : 0,
            )
            .slice(0, this.state.nbrOfNeighbors)
            .forEach((item) => {
              var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
              if (neighbor) {
                currentMarkerPositions.push(
                  new google.maps.LatLng(neighbor.latitude as number, neighbor.longitude as number),
                );
              }
            });
      }

      // Add new address position
      const transferCalculationResult = this.state.transferCalculationResult;
      if (
        transferCalculationResult !== undefined &&
        !Number.isNaN(transferCalculationResult.newLatitude) &&
        !Number.isNaN(transferCalculationResult.newLongitude)
      )
        currentMarkerPositions.push(
          new google.maps.LatLng(
            Number(transferCalculationResult.newLatitude),
            Number(transferCalculationResult.newLongitude),
          ),
        );

      //Add polygon coordinates
      if (includePolygon) {
        const paths = this.getPolygonCoordinates();
        paths.forEach((coord) => currentMarkerPositions.push(coord));
      }

      //Fit the bounds of the map to include the marker positions
      for (var i = 0; i < currentMarkerPositions.length; i++) {
        var marker = currentMarkerPositions[i];

        if (marker !== undefined) {
          bounds.extend(marker);
          hasBoundExtended = true;
        }
      }
      if (hasBoundExtended && this.state.map) {
        this.state.map.fitBounds(bounds);
        this.setState({ mapCenterLat: centerLat, mapCenterLong: centerLong });
        var newbounds = this.state.map.getBounds();
        if (newbounds === undefined || newbounds === null) return;
        for (i = 0; i < currentMarkerPositions.length; i++) {
          if (!newbounds.contains(currentMarkerPositions[i])) {
            const mapZoom = this.state.map.getZoom();
            if (mapZoom === undefined) return;
            this.state.map.setZoom(mapZoom - 1);
            break;
          }
        }
      }
    }
  };

  validateTransfer = (pharmacyToTransferSelected, neighbors) => {
    var latF = pharmacyToTransferSelected.latitude;
    var longF = pharmacyToTransferSelected.longitude;
    //@ts-ignore
    var F = new google.maps.LatLng(latF, longF); //pharmacie à transférer

    let newLocation: any = null;
    if (this.state.transferCalculationResult) {
      //icone de destination
      const destColor = '1528f2'; // blue
      //@ts-ignore
      newLocation = new google.maps.LatLng(
        Number(this.state.transferCalculationResult.newLatitude!),
        Number(this.state.transferCalculationResult.newLongitude!),
      );

      //const allPharmaciesForProtection = [...neighbors, pharmacyToTransferSelected];

      //this.determineStateOutsideProtectedCircle(newLocation, allPharmaciesForProtection);

      const isInsideCircle = this.isInsideCircle(F, newLocation, 100);
      if (this.state.isInsideCircle !== isInsideCircle) {
        this.setState({ isInsideCircle: isInsideCircle });
      }

      let isInsidePolygon = true;
      neighbors.forEach((item) => {
        var neighbor = this.props.PharmacyDetailedStore!.getByIdOrNew(item.neighborId);
        if (neighbor !== undefined) {
          const flag = this.isInsidePolygon(F, neighbor, newLocation);
          if (!flag) {
            isInsidePolygon = false;
            return;
          }
        }
      });
      if (this.state.isInsidePolygon !== isInsidePolygon) {
        this.setState({ isInsidePolygon: isInsidePolygon });
      }
    }
  };

  private addLineBetweenNeighborAndPharmacyToTransferToMarkers(
    neighbor: any,
    pharmacyToTransferLatLong: google.maps.LatLng,
    markers: any[],
  ) {
    // segment entre la pharmacie à transférer et la voisine
    var latT = neighbor!.latitude;
    var longT = neighbor!.longitude;
    var pharmacyNeighborLatLong = new google.maps.LatLng(latT, longT);

    var radiusLineCoordinates = [pharmacyToTransferLatLong, pharmacyNeighborLatLong];

    const segment = (
      <>
        {this.state.showRadius && (
          <Polyline
            key={'radius-' + neighbor.pharmacyId}
            path={radiusLineCoordinates}
            options={{
              geodesic: true,
              strokeColor: 'grey',
              strokeOpacity: 0.7,
              strokeWeight: 1,
            }}
          />
        )}
      </>
    );
    markers.push(segment);
  }

  private addNeighborPharmacyMarker(neighbor: any, markers: any[]) {
    const neighborIcon = generateCustomIcon(
      20,
      20,
      neighbor.isActive ? this.neighborColor : 'CACFD2',
      neighbor.isActive ? this.neighborColor : 'CACFD2',
      neighbor.level === 3,
      '000000',
      false,
      '888888',
      '1',
      '1',
    );

    const neighborPosition = (
      <PharmacyMarker
        key={'neighbor-' + neighbor.pharmacyId}
        id={neighbor.pharmacyId}
        marker={neighbor}
        zIndex={100}
        icon={neighborIcon}
        groupEditMode={false}
        protections={neighbor.protections.filter((p) => p.status === '+' && new Date(p.endDate) >= new Date())}
        disableRightClick
        onAddCircle={this.openAddCircleToMarkerDialog}
      />
    );
    markers.push(neighborPosition);
  }

  private toggleNewPositionMarkerInfo = () => {
    const currentState = !this.state.newPositionMarkerInfoVisible;
    this.setState({ newPositionMarkerInfoVisible: currentState });
  };

  private createNewLocationMarker(newLocation: any, markers: any[]) {
    const destColor = '1528f2'; // blue

    if (
      this.state.transferCalculationResult !== undefined &&
      !Number.isNaN(this.state.transferCalculationResult.newLatitude) &&
      !Number.isNaN(this.state.transferCalculationResult.newLongitude)
    )
      newLocation = new google.maps.LatLng(
        Number(this.state.transferCalculationResult.newLatitude),
        Number(this.state.transferCalculationResult.newLongitude),
      );
    else newLocation = new google.maps.LatLng(this.state.newLat!, this.state.newLong!);
    let targetIcon = generateCustomIcon(20, 20, destColor, destColor, true, '000000', false, '888888', '1', '1');
    const newPosition = (
      <Marker
        key={'target'}
        position={{
          lat: newLocation!.lat(),
          lng: newLocation!.lng(),
        }}
        icon={targetIcon}
        onClick={this.toggleNewPositionMarkerInfo}
      >
        {this.state.newPositionMarkerInfoVisible && (
          <InfoWindow onCloseClick={this.toggleNewPositionMarkerInfo} options={{ disableAutoPan: true }}>
            <div style={{ minWidth: '250px', minHeight: '70px' }}>
              <DivLine>
                <b>{this.props.translate(TLCode.PHARMACY_Latitude) + ':'}</b>
                {' ' + this.state.transferCalculationResult!.newLatitude}
              </DivLine>
              <DivLine>
                <b>{this.props.translate(TLCode.PHARMACY_Longitude) + ':'}</b>
                {' ' + this.state.transferCalculationResult!.newLongitude}
              </DivLine>
              <DivLine
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <Button
                  style={{ fontSize: 12 }}
                  text={this.props.translate(TLCode.TRANSFER_AddCircleDialogTitle)}
                  onClick={() => {
                    this.toggleNewPositionMarkerInfo();
                    this.openAddCircleToMarkerDialog(
                      Number(this.state.transferCalculationResult!.newLatitude),
                      Number(this.state.transferCalculationResult!.newLongitude),
                    );
                  }}
                />
              </DivLine>
            </div>
          </InfoWindow>
        )}
      </Marker>
    );
    markers.push(newPosition);
    return newLocation;
  }

  public render() {
    const { pharmacyList, getPharmacyById, onSave, translate, PharmacyStore, PharmacyDetailedStore } = this.props;
    const {
      isInsidePolygon,
      isInsideCircle,
      isOutsideProtectedCircles,
      initialZoomCalculated,
      mapCenterLong,
      mapCenterLat,
      map,
    } = this.state;

    const dirty = this.getIsDirty();
    const somethingToSave = this.somethingToSave();

    const userLocation = this.state.userLocation!;

    const processNewAddress = async (newLat: string, newLong: string, municipality: Instance<typeof Municipality>) => {
      onSave();
      this.verifyCoordinates();
      const closestPharmacy: any = await this.props.PharmacyStore!.getClosestPharmacyFrom(
        Number(newLat),
        Number(newLong),
        this.state.pharmacyToTransferSelected === undefined
          ? undefined
          : this.state.pharmacyToTransferSelected!.pharmacyId,
      );
      this.props.PharmacyStore!.loadElement(closestPharmacy.pharmacyId);
      let result = {
        pharmacyToTransferId:
          this.state.pharmacyToTransferSelected === undefined
            ? undefined
            : this.state.pharmacyToTransferSelected!.pharmacyId,
        newLatitude: newLat,
        newLongitude: newLong,
        newMunicipality: municipality,
        distance: 50,
        within100Meters: true,
        insidePolygon: false,
        nbrPharmacies: 1,
        nbrMinPharmacies: 1,
        nbrMaxPharmacies: 7,
        closestPharmacyId: closestPharmacy.pharmacyId,
        closestPharmacyDistance: closestPharmacy.distance,
        nbrInhabitantsInZone: 2500,
      } as Instance<typeof TransferCalculationResult>;
      result.nbrInhabitantsInZone = municipality.population;
      /*
      const municipalityPharmacyList = PharmacyStore!.dataList.filter(
        (ph) => ph.municipalityId == municipality.municipalityId,
      );
      result.nbrPharmacies = municipalityPharmacyList.length; // nbr actuel dans l'entité cible
*/
      result.nbrPharmacies = municipality.nbrPharmaciesMain;
      if (this.state.pharmacyToTransferSelected!.municipalityId == municipality.municipalityId) {
        // la pharmacie ne change pas d'entité => nbr de pharamacies ne change pas
        result.nbrMinPharmacies = -1;
        result.nbrMaxPharmacies = -1;
      } else {
        result.nbrMinPharmacies = 1; // dans l'entité d'origine
        result.nbrMaxPharmacies = Math.floor(result.nbrInhabitantsInZone / 5000); // dans l'entité cible
      }

      if (this.state.pharmacyToTransferSelected!.pharmacyId !== undefined)
        this.props.PharmacyDetailedStore!.loadElement(this.state.pharmacyToTransferSelected!.pharmacyId)!;

      this.props.PharmacyDetailedStore!.loadNeighboringPharmacies(this.state.pharmacyToTransferSelected!.pharmacyId);

      this._isMounted && this.setState({ transferCalculationResult: result });

      assessTransfer();
    };

    const assessTransfer = () => {
      const neighbors = (this.state.pharmacyToTransferSelected as any).pharmacyNeighbors
        .slice()
        .sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));
      //@ts-ignore

      this.validateTransfer(this.state.pharmacyToTransferSelected, neighbors.slice(0, this.state.nbrOfNeighbors));
    };

    const closestPharmacyText = () => {
      const transferCalculationResult = this.state.transferCalculationResult;
      if (transferCalculationResult === undefined || transferCalculationResult.closestPharmacyId === undefined)
        return '';
      const pharmacy = PharmacyStore!.getById(transferCalculationResult.closestPharmacyId);
      if (pharmacy === undefined) return '';
      const city = pharmacy.city ? pharmacy.city : '';
      return (
        '(' +
        pharmacy.level +
        (pharmacy.group !== undefined
          ? ' ' + translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP) + ' ' + pharmacy.group
          : '') +
        ') - ' +
        (pharmacy.apbNumber ? pharmacy.apbNumber + ' - ' : '') +
        pharmacy.name! +
        (' ' + pharmacy.address + ', ' + pharmacy.zipCode + ' ' + city)
      );
    };

    const calculateCoordinates = async (address: string): Promise<[number, number, typeof Municipality]> => {
      let lat: number = 0;
      let long: number = 0;
      let city: string = '';
      let district: string = '';
      let postalCode: number = 0;
      let entity: typeof Municipality;
      let tryAnotherApi = false;
      this.verifyCoordinates();
      const municipalityList = this.props.MunicipalityStore!.dataList.filter(
        (municipality) => municipality.postalCode > 0,
      );
      this.setState({ searchedAddress: address });
      await getHERECoordinatesFromAddress(address)
        .then((result) => {
          if (result === undefined || result[0] === undefined) {
            tryAnotherApi = true;
            return;
          }
          if (result[0].resultType == 'houseNumber' || result[0].resultType == 'locality') {
            lat = Number(result[0].position.lat);
            long = Number(result[0].position.lng);
            city = result[0].address.city;
            district = result[0].address.district !== undefined ? result[0].address.district : '';
            postalCode =
              result[0].address.postalCode !== undefined && !isNaN(Number(result[0].address.postalCode))
                ? Number(result[0].address.postalCode)
                : 0;

            const municipality = district && district.length > 0 ? district.toUpperCase() : city.toUpperCase();

            const final = municipalityList.filter(
              (item) => item.postalCode == postalCode,
              // (item) => item.postalCode == postalCode && item.mainNameFR == city && item.nameFR == municipality,
            );

            if (final.length === 0 || final[0] === undefined) {
              tryAnotherApi = true;
              return;
            }

            //@ts-ignore
            processNewAddress(result[0].position.lat, result[0].position.lng, final[0]);
            //@ts-ignore
            entity = final[0];
          }
        })
        .catch();

      if (tryAnotherApi)
        await getCoordinatesFromAddress(address)
          .then((result) => {
            if (result === undefined || result[0] === undefined) return;
            lat = Number(result[0].lat);
            long = Number(result[0].lon);
            postalCode =
              result[0].address.postcode !== undefined && !isNaN(Number(result[0].address.postcode))
                ? Number(result[0].address.postcode)
                : 0;

            city = result[0].address.city !== undefined ? result[0].address.city : '';
            district = result[0].address.municipality !== undefined ? result[0].address.municipality : '';

            const municipality =
              district && district.length > 0
                ? district.toUpperCase()
                : city.length > 0
                ? city.toUpperCase()
                : result[0].address.town !== undefined && result[0].address.town.length > 0
                ? result[0].address.town.toUpperCase()
                : result[0].address.village;

            const final = municipalityList.filter(
              (item) => item.postalCode == postalCode,
              // (item) => item.postalCode == postalCode && item.mainNameFR == city && item.nameFR == municipality,
            );

            if (final.length === 0 || final[0] === undefined) {
              this._isMounted &&
                this.setState({ openMunicipalityDialog: true, newLat: lat, newLong: long, isVerified: false });
              return;
            }

            //@ts-ignore
            processNewAddress(result[0].position.lat, result[0].position.lng, final[0]);
            //@ts-ignore
            entity = final[0];
          })
          .catch();

      //@ts-ignore
      return [lat, long, entity];
    };

    const fromLambert2008ToWGS84 = (x: number, y: number): [number, number] => {
      //lambert2008
      proj4.defs(
        'EPSG:3812',
        '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      );
      const result = proj4(this.lambert2008, this.wgs84, [x, y]);
      const lat = result[1];
      const lng = result[0];

      return [lat, lng];
    };

    const fromWGS84ToLambert2008 = (lat: number, long: number): [number, number] => {
      //lambert2008
      proj4.defs(
        'EPSG:3812',
        '+proj=lcc +lat_1=49.83333333333334 +lat_2=51.16666666666666 +lat_0=50.797815 +lon_0=4.359215833333333 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      );
      const result = proj4(this.wgs84, this.lambert2008, [long, lat]);
      const x = result[0];
      const y = result[1];

      return [x, y];
    };

    const calculateFromLambert2008ToWGS84 = async (x: number, y: number): Promise<[number, number]> => {
      const wgs84Coordinates = fromLambert2008ToWGS84(x, y);
      const lat = wgs84Coordinates[0];
      const lng = wgs84Coordinates[1];

      await getHEREAddressFromCoordinates(lat.toString(), lng.toString()).then((result) => {
        if (result.status == 200) {
          const mnp = this.props.MunicipalityStore!.dataList.find(
            (mn) =>
              mn.mainNameFR == result.data.items[0].address.city &&
              mn.postalCode == result.data.items[0].address.postalCode,
          );
          if (this.state.pharmacyToTransferSelected === undefined) return;
          if (mnp === undefined) {
            this._isMounted && this.setState({ openMunicipalityDialog: true, newLat: lat, newLong: lng });
            return;
          }
          processNewAddress(lat.toString(), lng.toString(), mnp!);
        }
      });
      return wgs84Coordinates;
    };

    const selectableMunicipalities = this.props.MunicipalityStore!.dataList.filter(
      (municipality) => municipality.postalCode > 0,
    );

    const onMunicipalitySelected = (municipality) => {
      if (
        this.state.selectedMunicipality === undefined ||
        this.state.selectedMunicipality.municipalityId !== municipality.municipalityId
      ) {
        this.setState({ selectedMunicipality: municipality });
      }
    };

    return (
      <>
        <AddUserDefinedCircleDialog
          isOpen={this.state.openAddCircleDialog}
          onClose={() => {
            this.setState({ openAddCircleDialog: false });
          }}
          circleLat={this.state.userAddedCircleLat !== undefined ? this.state.userAddedCircleLat : 0}
          circleLng={this.state.userAddedCircleLng !== undefined ? this.state.userAddedCircleLng : 0}
          onCircleAdd={this.onCircleAdded}
        />
        {!this.state.isVerified && (
          <MunicipalitySelectionDialog
            onMunicipalitySelected={onMunicipalitySelected}
            selectedMunicipality={this.state.selectedMunicipality}
            isDialogOpen={this.state.openMunicipalityDialog}
            municipalities={selectableMunicipalities}
            confirmSelection={() => {
              processNewAddress(
                this.state.newLat!.toString(),
                this.state.newLong!.toString(),
                this.state.selectedMunicipality,
              );
            }}
            onClose={() => this.setState({ openMunicipalityDialog: false })}
            infoText={translate(TLCode.MUNICIPALITY_Selection_Message)}
          />
        )}
        <Container>
          <Form
            initialValues={{}}
            onSubmit={onSave}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <FormContainer>
                  <DivLine>
                    <DivColumn style={{ width: '100%', marginTop: '5px' }}>
                      <PharmacySelectionDetailsTransfer
                        pharmacyLabelCode={TLCode.TRANSFER_PharmacyToTransfer}
                        pharmacyList={pharmacyList as Array<Instance<typeof Pharmacy>>}
                        onChange={this.onPharmacyToTransferSelected}
                        getPharmacyById={getPharmacyById}
                        pharmacySelected={this.state.pharmacyToTransferSelected}
                        pharmacyLabelColor={'green'}
                        pharmacyTextColor={'white'}
                        simpleTransfer={true}
                        translate={translate}
                        convertWGS84ToLambert2008={fromWGS84ToLambert2008}
                      />
                    </DivColumn>
                  </DivLine>
                  <DivLine style={{ width: '100%', marginTop: '5px' }}>
                    {this.state.pharmacyToTransferSelected && (
                      <NewAddressForm
                        calculateCoordinates={calculateCoordinates}
                        convertLambert2008ToWGS84={calculateFromLambert2008ToWGS84}
                        convertWGS84ToLambert2008={fromWGS84ToLambert2008}
                        translate={translate}
                        feededCoordinatesLat={
                          this.state.transferCalculationResult !== undefined
                            ? this.state.transferCalculationResult.newLatitude
                            : this.state.newLat !== undefined
                            ? this.state.newLat.toString()
                            : undefined
                        }
                        feededCoordinatesLong={
                          this.state.transferCalculationResult !== undefined
                            ? this.state.transferCalculationResult.newLongitude
                            : this.state.newLong !== undefined
                            ? this.state.newLong.toString()
                            : undefined
                        }
                        feededAddress={this.state.searchedAddress}
                        pharmacyLabelColor={'blue'}
                        pharmacyTextColor={'white'}
                      />
                    )}
                  </DivLine>
                </FormContainer>
              </form>
            )}
          />
          {this.state.isVerified && (
            <>
              <DivLine style={{ marginTop: '10px', color: 'darkgrey' }}>
                <DivLeftColumn style={{ width: '60%' }}>
                  <DivLine
                    style={{
                      textAlign: 'center',
                      justifyContent: 'space-between',
                      alignContent: 'space-between',
                      gap: '10px',
                      marginRight: '25px',
                    }}
                  >
                    <DivColumn style={{ width: '120px' }}>
                      <TranslatedMessage id={TLCode.TRANSFER_Distance} />
                    </DivColumn>
                    <DivColumn style={{ width: '90px' }}>
                      <TextInput
                        value={
                          this.state.transferCalculationResult !== undefined &&
                          this.state.transferCalculationResult.distance !== undefined
                            ? this.state.transferCalculationResult!.distance!.toString()
                            : undefined
                        }
                        disabled
                      />
                    </DivColumn>
                    <Checkbox
                      label={translate(TLCode.TRANSFER_InsideCircle)}
                      checked={this.state.isInsideCircle}
                      // checked={this.state.isInsideCircle !== undefined ? this.state.isInsideCircle : false}
                      //disabled
                    />
                    <Checkbox
                      label={translate(TLCode.TRANSFER_InsidePolygon)}
                      checked={this.state.isInsidePolygon !== undefined ? this.state.isInsidePolygon : false}
                      //disabled
                    />
                    {/* <Checkbox
                      label={translate(TLCode.TRANSFER_OutsideProtectedCircles)}
                      checked={
                        this.state.isOutsideProtectedCircles
                        // this.state.isOutsideProtectedCircles !== undefined ? this.state.isOutsideProtectedCircles : false
                      }
                      // disabled
                    /> */}
                    {(isInsidePolygon || isInsideCircle) && isOutsideProtectedCircles && (
                      <DivLine style={{ backgroundColor: 'green', color: 'white' }}>
                        &nbsp;Localisation autorisée&nbsp;
                      </DivLine>
                    )}
                    {((!isInsidePolygon && !isInsideCircle) || !isOutsideProtectedCircles) && (
                      <DivLine style={{ backgroundColor: 'red', color: 'white' }}>
                        &nbsp;Localisation interdite&nbsp;
                      </DivLine>
                    )}
                  </DivLine>
                </DivLeftColumn>
                <DivRightColumn style={{ width: '40%' }}>
                  <DivLine
                    style={{
                      justifyContent: 'flex-end',
                      alignContent: 'flex-end',
                      gap: '10px',
                      // marginLeft: '10px',
                      textAlign: 'right',
                    }}
                  >
                    <DivColumn style={{ width: '120px' }}>
                      <TranslatedMessage id={TLCode.TRANSFER_PharmacyNbrPharmacies} />
                    </DivColumn>
                    <DivColumn style={{ width: '40px' }}>
                      <TextInput
                        value={
                          this.state.transferCalculationResult !== undefined &&
                          this.state.transferCalculationResult.nbrPharmacies !== undefined
                            ? this.state.transferCalculationResult!.nbrPharmacies!.toString()
                            : undefined
                        }
                        disabled
                      />
                    </DivColumn>
                    {this.state.transferCalculationResult !== undefined &&
                      this.state.transferCalculationResult.nbrMinPharmacies !== undefined &&
                      this.state.transferCalculationResult.nbrMinPharmacies > 0 && (
                        <>
                          <DivColumn style={{ width: '150px' }}>
                            <TranslatedMessage id={TLCode.TRANSFER_NbrMinPharmacies} />
                          </DivColumn>
                          <DivColumn style={{ width: '30px' }}>
                            <TextInput
                              value={
                                this.state.transferCalculationResult !== undefined &&
                                this.state.transferCalculationResult.nbrMinPharmacies !== undefined
                                  ? this.state.transferCalculationResult!.nbrMinPharmacies!.toString()
                                  : undefined
                              }
                              disabled
                            />
                          </DivColumn>
                          <DivColumn style={{ width: '120px' }}>
                            <TranslatedMessage id={TLCode.TRANSFER_NbrMaxPharmacies} />
                          </DivColumn>
                          <DivColumn style={{ width: '40px' }}>
                            <TextInput
                              value={
                                this.state.transferCalculationResult !== undefined &&
                                this.state.transferCalculationResult.nbrMaxPharmacies !== undefined
                                  ? this.state.transferCalculationResult!.nbrMaxPharmacies!.toString()
                                  : undefined
                              }
                              disabled
                              style={{
                                backgroundColor:
                                  this.state.transferCalculationResult !== undefined &&
                                  this.state.transferCalculationResult.nbrPharmacies !== undefined &&
                                  this.state.transferCalculationResult.nbrMaxPharmacies !== undefined
                                    ? this.state.transferCalculationResult.nbrMaxPharmacies < 0
                                      ? 'light-grey'
                                      : this.state.transferCalculationResult.nbrPharmacies <
                                        this.state.transferCalculationResult.nbrMaxPharmacies
                                      ? 'lightgreen'
                                      : 'red'
                                    : 'light-grey',
                                color: 'darkgrey',
                                // width: '30px',
                              }}
                            />
                          </DivColumn>
                        </>
                      )}
                    {this.state.transferCalculationResult !== undefined &&
                      this.state.transferCalculationResult.nbrMinPharmacies !== undefined &&
                      this.state.transferCalculationResult.nbrMinPharmacies < 0 && <>pas de changement de commune</>}
                  </DivLine>
                </DivRightColumn>
              </DivLine>
              <DivLine style={{ marginTop: '20px', color: 'darkgrey', gap: '10px', textAlign: 'right' }}>
                <span style={{ width: '100%' }}>
                  <TranslatedMessage id={TLCode.TRANSFER_ClosestPharmacy} />
                </span>
                <span
                  style={{
                    width: '350%',
                  }}
                >
                  <TextInput value={closestPharmacyText()} disabled />
                </span>
                <span style={{ width: '100%' }}>
                  <TranslatedMessage id={TLCode.TRANSFER_Distance} />
                </span>
                <span
                  style={{
                    width: 'auto',
                  }}
                >
                  <TextInput
                    value={
                      this.state.transferCalculationResult !== undefined &&
                      this.state.transferCalculationResult.closestPharmacyDistance !== undefined
                        ? this.state.transferCalculationResult.closestPharmacyDistance.toString()
                        : ''
                    }
                    style={{
                      width: '60px',
                    }}
                    disabled
                  />
                </span>
                <span style={{ width: '100%' }}>
                  <TranslatedMessage id={TLCode.TRANSFER_NbrInhabitantsInZone} />
                </span>
                <span
                  style={{
                    width: 'auto',
                  }}
                >
                  <TextInput
                    value={
                      this.state.transferCalculationResult !== undefined &&
                      this.state.transferCalculationResult.nbrInhabitantsInZone !== undefined
                        ? this.state.transferCalculationResult.nbrInhabitantsInZone.toString()
                        : ''
                    }
                    style={{
                      width: '60px',
                    }}
                    disabled
                  />
                </span>
              </DivLine>
            </>
          )}
          &nbsp;&nbsp;
          <LeaveRouteDirtyWrapper blockChange={dirty} />
          <DivLine style={{ display: 'flex' }}>
            <DivColumn style={{ height: '637px', width: '1307px', paddingRight: '5px' }}>
              <PharmagardeMap
                center={
                  mapCenterLat === undefined || mapCenterLong === undefined
                    ? undefined
                    : { lat: mapCenterLat, lng: mapCenterLong }
                }
                onLoad={(map: google.maps.Map) => {
                  this.setState({ map });
                  this.setState({ initialZoomCalculated: true });
                }}
                gridSize={5}
                maximalZoom={18}
                minimalZoom={1}
                initialZoom={18}
                zoom={this.state.zoom}
                onRightClick={async (event) => {
                  if (this.state.pharmacyToTransferSelected === undefined) return;
                  this.setState({ searchedAddress: '' });
                  if (event === null || event.latLng === null) return;
                  await getHEREAddressFromCoordinates(
                    event.latLng.lat().toString(),
                    event.latLng.lng().toString(),
                  ).then((result) => {
                    if (result.status == 200) {
                      const mnp = this.props.MunicipalityStore!.dataList.find(
                        (mn) =>
                          mn.mainNameFR == result.data.items[0].address.city &&
                          mn.postalCode == result.data.items[0].address.postalCode,
                      );
                      if (this.state.pharmacyToTransferSelected == undefined) return;
                      if (event === null || event.latLng === null) return;
                      const roundedLat = Math.round(event.latLng.lat() * 1000000) / 1000000;
                      const roundedLng = Math.round(event.latLng.lng() * 1000000) / 1000000;
                      if (mnp === undefined) {
                        this._isMounted &&
                          this.setState({
                            openMunicipalityDialog: true,
                            newLat: roundedLat,
                            newLong: roundedLng,
                          });
                        return;
                      }
                      processNewAddress(roundedLat.toString(), roundedLng.toString(), mnp!);
                      this.calculateZoom(roundedLat, roundedLng);
                    }
                  });
                }}
              >
                {initialZoomCalculated
                  ? this.state.userAddedCircles !== undefined
                    ? [...this.renderPharmacyMarkers(), ...this.state.userAddedCircles]
                    : [...this.renderPharmacyMarkers()]
                  : undefined}
              </PharmagardeMap>
            </DivColumn>
            <DivColumn style={{ width: '150px' }}>
              <DivLine style={{ width: '150px', height: '160px' }}>
                <DivColumn style={{ width: '150px' }}>
                  <TranslatedMessage id={TLCode.TRANSFER_NeighborCount} />
                  <DivLine style={{ width: '150px', height: '50px' }}>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomNeighbors)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              this.state.pharmacyToTransferSelected.latitude!,
                              this.state.pharmacyToTransferSelected.longitude!,
                              true,
                            );
                          }
                        }}
                        className={this.yellowBackgroundColor.toString()}
                      />
                    </Tooltip>
                    <NumericInput
                      style={{ width: '60px' }}
                      min={1}
                      value={this.state.nbrOfNeighbors}
                      onValueChange={this.handleNbrOfNeighborsChanged}
                    />
                  </DivLine>
                  {/* <DivLine style={{ width: '150px', height: '50px', marginTop: '10px' }}>
                    <DivColumn style={{ width: '50px' }}>
                      <Button
                        text={translate(TLCode.TRANSFER_EstimateNeighborCount)}
                        intent={Intent.SUCCESS}
                        onClick={() => {
                          this.estimateNeighborCount();
                        }}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: '40px' }}>
                      <TextInput
                        min={1}
                        value={(this.state.estimatedNbrOfNeighbors ? this.state.estimatedNbrOfNeighbors : 0).toString()}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: '50px' }}>
                      <Button
                        text={translate(TLCode.TRANSFER_Calculate)}
                        intent={Intent.SUCCESS}
                        onClick={() => {
                          this.setState({
                            nbrOfNeighbors: this.state.estimatedNbrOfNeighbors ? this.state.estimatedNbrOfNeighbors : 0,
                          });
                        }}
                      />
                    </DivColumn>
                  </DivLine> */}
                  <DivLine style={{ width: '150px', marginTop: '10px' }}>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomPharmacy)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              this.state.pharmacyToTransferSelected.latitude!,
                              this.state.pharmacyToTransferSelected.longitude!,
                            );
                          }
                        }}
                        className={this.greenBackgroundColor.toString()}
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomHalfHalf)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined &&
                            this.state.transferCalculationResult !== undefined &&
                            this.state.transferCalculationResult.newLatitude !== undefined &&
                            this.state.transferCalculationResult.newLongitude !== undefined
                          ) {
                            this.centerAndZoom(
                              (this.state.pharmacyToTransferSelected.latitude! +
                                Number(this.state.transferCalculationResult.newLatitude!)) /
                                2,
                              (this.state.pharmacyToTransferSelected.longitude! +
                                Number(this.state.transferCalculationResult.newLongitude!)) /
                                2,
                            );
                          }
                        }}
                        text="1/2"
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomDestination)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.transferCalculationResult !== undefined &&
                            this.state.transferCalculationResult.newLatitude !== undefined &&
                            this.state.transferCalculationResult.newLongitude !== undefined
                          ) {
                            this.centerAndZoom(
                              Number(this.state.transferCalculationResult.newLatitude!),
                              Number(this.state.transferCalculationResult.newLongitude!),
                            );
                          }
                        }}
                        className={this.blueBackgroundColor.toString()}
                      />
                    </Tooltip>
                    <Tooltip
                      className={Classes.TOOLTIP_INDICATOR}
                      content={translate(TLCode.TRANSFER_ZoomPolygon)}
                      hoverOpenDelay={1000}
                    >
                      <Button
                        icon={IconNames.LOCATE}
                        onClick={() => {
                          if (
                            this.state.pharmacyToTransferSelected !== undefined &&
                            this.state.pharmacyToTransferSelected.latitude !== undefined &&
                            this.state.pharmacyToTransferSelected.longitude !== undefined
                          ) {
                            this.centerAndZoom(
                              this.state.pharmacyToTransferSelected.latitude!,
                              this.state.pharmacyToTransferSelected.longitude!,
                              false,
                              true,
                            );
                          }
                        }}
                        className={this.polygonBackgroundColor.toString()}
                      />
                    </Tooltip>
                  </DivLine>
                  <DivLine style={{ fontWeight: 'bold', color: 'red' }}>
                    <TranslatedMessage id={TLCode.TRANSFER_PolygonNotOptimized} />
                  </DivLine>
                </DivColumn>
              </DivLine>
              {/* <DivLine style={{ width: '150px', marginTop: '40px' }}>
                <DivColumn style={{ width: '100%' }}>
                  <TranslatedMessage id={TLCode.TRANSFER_PerpendicularLength} />

                  <TextInput
                    value={this.state.lengthOfPerpendiculars.toString()}
                    onChange={this.lengthOfPerpendicularsChanged}
                  />
                </DivColumn>
              </DivLine> */}

              <DivLine>
                <DivColumn style={{ width: '120px' }}>
                  <Checkbox
                    label={translate(TLCode.TRANSFER_Show100mCircle)}
                    onChange={() => this.setState({ show100mCircle: !this.state.show100mCircle })}
                    checked={this.state.show100mCircle !== undefined ? this.state.show100mCircle : false}
                  />
                </DivColumn>
              </DivLine>
              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <Checkbox
                    label={translate(TLCode.TRANSFER_ShowPerpendiculars)}
                    onChange={() => this.setState({ showPerpendiculars: !this.state.showPerpendiculars })}
                    checked={this.state.showPerpendiculars !== undefined ? this.state.showPerpendiculars : false}
                  />
                </DivColumn>
              </DivLine>

              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <Checkbox
                    label={translate(TLCode.TRANSFER_ShowRadius)}
                    onChange={() => this.setState({ showRadius: !this.state.showRadius })}
                    checked={this.state.showRadius !== undefined ? this.state.showRadius : false}
                  />
                </DivColumn>
              </DivLine>
              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <Checkbox
                    label={translate(TLCode.TRANSFER_ShowProtectionCircles)}
                    onChange={() => this.setState({ showProtectionCircles: !this.state.showProtectionCircles })}
                    checked={this.state.showProtectionCircles !== undefined ? this.state.showProtectionCircles : false}
                  />
                </DivColumn>
              </DivLine>
              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <Checkbox
                    label={translate(TLCode.TRANSFER_ShowPolygons)}
                    onChange={() => this.setState({ showPolygons: !this.state.showPolygons })}
                    checked={this.state.showPolygons !== undefined ? this.state.showPolygons : false}
                  />
                </DivColumn>
              </DivLine>

              <DivLine>
                <DivColumn style={{ width: '100%' }}>
                  <DivLine style={{ width: '150px', height: '25px' }}>
                    <Checkbox
                      label={translate(TLCode.TRANSFER_ShowIntersection)}
                      onChange={() => this.setState({ showIntersection: !this.state.showIntersection })}
                      checked={this.state.showIntersection !== undefined ? this.state.showIntersection : false}
                    />
                  </DivLine>
                </DivColumn>
              </DivLine>
            </DivColumn>
          </DivLine>
        </Container>
      </>
    );
  }
}

export default withTranslate(SimpleTransferTab);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 5px;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const DivLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  width: 50%;
`;

const DivRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  width: 50%;
`;
